<template>


    <footer class="row mt-5">
       
        <div class="py-5 ">
            <div class="container ">
                <div class="row gx-5">
                    <div class="col-12">
                        <div class="chatIcon"><img src="@/assets/images/accessabilty_icon.png" alt="" class="img-fliud"></div>
                    </div>
                    <div class="col-md-12 col-lg-4 my-4">
                        <h5>أتصل بنا</h5>
                        <p>
                            تم تخصيص الارقام التالية لتيسير ولتلبية
                            احتياج المواطنين لمصدرات القطاع الفورية<br/>
                            <a href="tel:15340">15340</a> -  <a href="tel:15341">15341</a> -  <a href="tel:16582">16582</a><br/>
                            <a href="tel:02-24004400 ">02/24004400 </a> - <a href="tel:090070999">090070999</a><br/>
                        </p>
                        <div class="social_icons d-flex ">
                            <a href="https://www.youtube.com/c/moiegy"><img src="@/assets/images/you-tube-icon.png" alt=""></a>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-2 my-4">
                        <h5>خدمات القطاع</h5> 
                        <ul>
                            <li> <a  href="#" @click="ToElectronicServices">الخدمات الالكترونية</a> </li>
                            <li> <a href="#" @click="ToTranslatedServices"> خدمات الوثائق المترجمة</a> </li>
                            <li> <a href="#" @click="ToAudio"> الخدمات صوتية</a> </li>
                            <li> <a href="#" @click="ToSoon"> إرشادات الصم والبكم</a> </li>
                        </ul>
                    </div>
                    <div class="col-md-4 col-lg-2 my-4">
                        <h5>روابط تهمك</h5> 
                        <ul>
                            <li> <a  href="  https://moi.gov.eg ">  وزارة الداخلية</a> </li>
                        </ul>
    
    
    
                    </div>
                    <div class="col-md-4 col-lg-4 my-4">
                        <h5>متابعة حالة الطلب</h5>
                          <div class="form-floating mb-3">
                            <input v-model="RequestId" type="text" class="form-control" id="requestNumber" placeholder="أدخل رقم لطلب">
                            <label for="requestNumber">أدخل رقم لطلب</label>
                          </div>
                          <button @click="ToInquiryResult" :disabled="!RequestId" type="button" class="btn btn-primary">بحث <i class="bi bi-search"></i></button>
                    </div>
                    
                    <div class="col-12 my-4">
                        <div class="d-flex justify-content-center">
                               <a @click="ToHome()" href="#"><img src="@/assets/images/footer_logo.png" alt="" class="img-fluid"></a>
                        </div>
                    </div>
    
                    <div class="col-12 my-3 text-center">
                        جميع الحقوق محفوظة لوزارة الداخلية/قطاع الأحوال المدنية - جمهورية مصر العربية {{new Date().getFullYear()}}
                    </div>
                </div>
            </div>
        </div>
      
    </footer>
    
    
    </template>
    
    <script>
    export default {
      name: 'FooterComp',
      data(){
        return{
            RequestId:''
        }
      },
      methods:{
        ToHome(){
            this.$router.push({name: 'dashboard'})
        },
        ToInquiryResult(){
            this.$router.push({name:'inquiryResult',  params:{req_id:this.RequestId}});
        },
        ToElectronicServices(){
            this.$router.push({name: 'electronicservices'})
        },
        ToTranslatedServices(){
            this.$router.push({name: 'translatedservices'})
        },
        ToAudio(){
            this.$router.push({name: 'news4'})
        },
        ToSoon(){
            this.$router.push({name: 'soon'})
        },
    
      }
    }
    </script>